export interface Option {
    value: string;
    label: string;
  }

export const genders = [
  { value: "M", label: "Мужской" },
  { value: "F", label: "Женский" },
];